
import { ApiURLs,imageBaseUrls } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData, uploadImage } from "../../../services/api";

  


  export const contactUsLisitingRequest = (page=1,pageSize=10,keyword='') => {

    return async (dispatch) => {

      const url = `${ApiURLs.CONTACTUS}?offset=${page}&limit=${pageSize}&keyword=${keyword}`;
  

      console.log('CHECK:::::::',url,pageSize);
      // wait untill the data not received so getData function take data and url part
      dispatch({"type":"GET_CONTACT_US_REQUEST"});
      try {
        var contactUsData = await fetchData(url);
        console.log(`response when we try to get contact us  ${JSON.stringify(contactUsData)}`)
        if (contactUsData.status === 1) {
          dispatch({"type":"GET_CONTACT_US_REQUEST_SUCCESS", "payload":contactUsData.data.result,"total":contactUsData.data.total});
        
        } else {
          dispatch({"type":"GET_CONTACT_US_REQUEST_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"GET_CONTACT_US_REQUEST_FAILED"});
        console.log(`error while try to get contact us ${error}`)
      }
    }
  };



    export const deleteContactUs = (id) => {
      return async (dispatch) => {
    
        // dispatch();
        dispatch({"type":"DELETE_CONTACT_US_REQUEST"});
        try {
    
  
          var contactUsResponse = await deleteData(`${ApiURLs.CONTACTUS}/${id}`);
          if (contactUsResponse.status === 1) {
            dispatch({"type":"ADD_CONTACT_US_SUCCESS"});
            dispatch(contactUsLisitingRequest());
          } else {
            dispatch({"type":"ADD_CONTACT_US_FAILED"});
          }
        } catch (error) {
          dispatch({"type":"ADD_CONTACT_US_FAILED"});
    
        }
      };
    };
  

